import React, {useState} from "react";
import {createUseStyles} from "react-jss";
import Button from "engage-client/components/Button";
import Modal from "engage-client/components/Modal";
import HostPlayerDisplay from "./HostPlayerDisplay";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {Theme} from "engage-client/theme";


const useStyles = createUseStyles<Theme>((theme) => ({
	modal:{
		overflow: "scroll",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		maxHeight: 400,
		width: 300,
		
	},
	viewAll: {
		paddingTop: 20,
		alignSelf: "center",
		display: "flex",
		flexDirection: "column",
	},
	players: {
		width: "70%"
	}
}));

type HostViewAllProps = {
	number: number
	names: string[]
	maxToShow: number
	type: ViewAllType
}

export enum ViewAllType {
	Answers,
	Streak,
	Time 
}

const HostViewAll = ({number, names, maxToShow, type}:HostViewAllProps) => {
	const classes = useStyles();
	const [viewAll, setViewAll] = useState(false);
	let title;

	switch (type) {
		case ViewAllType.Answers:
			title = `Players with ${number} correct answers:`;
			break;
		case ViewAllType.Streak:
			title = `Players with longest hot streak of ${number}: `;
			break;
		case ViewAllType.Time:
			title = `Players with an average answer time of ${Math.round(number/100)/10} seconds: `;
			break;
		default: 
			title = "All players: ";
	}

	if (names.length > maxToShow) {
		return (
			<div className={classes.viewAll}>
				<DisplayText variant={TextVariant.s12med} color={"white"} style={{paddingBottom: 10}}>+{names.length - maxToShow} more...</DisplayText>
				<Button onClick={() => setViewAll(true)}>View All</Button>
				<Modal isVisible={viewAll} onBackdropClick={() => setViewAll(false)}>
					<div className={classes.modal}>
						{title}
						<div className={classes.players}>
							{names.map((name, index) => <HostPlayerDisplay name={name} key={index}/>)}
						</div>
					</div>
				</Modal>
			</div>);
			}
		return null;
	};

export default HostViewAll;